import {RemitDetailSerializer, RemitSerializer, RemitServiceLineSerializer} from '../@core/api.service';
import {assignOrCreate, ModelBase} from './model-base';
import {Payment} from './payment';

export class Remittance extends ModelBase implements RemitDetailSerializer {
    id?: number;
    payment?: Payment;
    // @ts-ignore
    claim?: Claim;
    first_name?: string;
    last_name?: string;
    origin_claim_id?: string;
    paid?: number;
    pos?: string;
    displayPaid: string;
    remit_service_lines?: RemitServiceLineSerializer[];
    claim_status_code?: string;

    static getIdentifier(x) {
        return `BST${x.id}`;
    }

    assign(remit: RemitSerializer) {
        super.assign(remit);
        //TODO: Implement currency pipe
        this.displayPaid = `$ ${this.paid}`;
        this.payment = assignOrCreate(Payment, remit.payment);
        this.claim = remit.claim;
    }
}
